/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: marc
 */
(function ($) {
    "use strict";

    Tc.Module.Linklist = Tc.Module.extend({

        config: {},

        on: function (callback) {
            var mod = this;

            mod.handleDropdownSelect();

            callback();
        },

        handleDropdownSelect: function () {
            var $ctx = this.$ctx;
            $('#archiveddl', $ctx).change(function (e) {
                window.location = $(this).val();
            });
        }

    });
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Linklist.js
// module id = 41
// module chunks = 0